import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { MaterialModule } from './../material';

@NgModule({
  imports: [CommonModule, MaterialModule, FormsModule, NgbDropdownModule],
})
export class CoreModule {}
